import { Link } from 'react-router-dom';
import './Legal.css';

// ── UPDATE THESE WHEN YOUR COMPANY IS REGISTERED ─────────────
const COMPANY       = 'SBH The Company';
const OWNER         = 'Slimane Ben Harbi';
const STREET        = 'Rosenbecker Str. 27a';
const CITY          = '12689 Berlin';
const COUNTRY       = 'Germany';
const EMAIL         = 'contact@transportily.app';
const PHONE         = '[Your phone number]'; // optional but recommended
const TAX_NR        = '[Steuernummer after registration]'; // e.g. 12/345/67890
const VAT_ID        = '[USt-IdNr after registration]'; // e.g. DE123456789 — optional
// ─────────────────────────────────────────────────────────────

export default function Impressum() {
  return (
    <div className="page legal-page">
      <div className="container legal-container">
        <div className="legal-header">
          <Link to="/" className="auth-logo" style={{ marginBottom: '24px', display: 'inline-block' }}>
            Transport<span>ily</span>
          </Link>
          <h1>Impressum</h1>
          <p className="legal-meta">Legal notice — required under § 5 TMG and § 55 RStV</p>
        </div>

        <div className="legal-body">

          <section>
            <h2>Angaben gemäß § 5 TMG</h2>
            <p>
              <strong>{COMPANY}</strong><br />
              Inhaber: {OWNER}<br />
              {STREET}<br />
              {CITY}<br />
              {COUNTRY}
            </p>
          </section>

          <section>
            <h2>Kontakt</h2>
            <p>
              E-Mail: <a href={`mailto:${EMAIL}`}>{EMAIL}</a><br />
              {PHONE !== '[Your phone number]' && <>Telefon: {PHONE}<br /></>}
            </p>
          </section>

          <section>
            <h2>Verantwortlich für den Inhalt</h2>
            <p>{OWNER}</p>
          </section>

          {TAX_NR !== '[Steuernummer after registration]' && (
            <section>
              <h2>Steuernummer</h2>
              <p>{TAX_NR}</p>
            </section>
          )}

          {VAT_ID !== '[USt-IdNr after registration]' && (
            <section>
              <h2>Umsatzsteuer-ID</h2>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:<br />
                {VAT_ID}
              </p>
            </section>
          )}

          <section>
            <h2>Streitschlichtung / Dispute Resolution</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
            <p style={{ marginTop: '12px', color: 'rgba(245,237,216,0.5)', fontSize: '13px' }}>
              <em>
                The European Commission provides a platform for online dispute resolution (ODR).
                We are not obligated to participate in dispute resolution proceedings before a
                consumer arbitration board.
              </em>
            </p>
          </section>

          <section>
            <h2>Haftung für Inhalte / Liability for Content</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
              allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
              erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>
          </section>

          <section>
            <h2>Haftung für Links / Liability for Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
              übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2>Urheberrecht / Copyright</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

        </div>

        <div className="legal-footer">
          <Link to="/terms">Terms of Service</Link>
          <span>·</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span>·</span>
          <Link to="/">Back to Transportily</Link>
        </div>
      </div>
    </div>
  );
}